import { Radio, Checkbox } from 'antd';
import { ZorbaInput } from '../../../../../components/forms';

import './index.scss';

export default (props) => {
  const onChange = (values, key) => {
    if (key === 'currentGoal') {
      props.onChange('', {
        currentGoal: values,
        currentGoalExplanation: [],
      });
    } else {
      props.onChange(key, values);
    }
  };
  const {
    params: {
      buyingStrategy,
      buyingVolume,
      ownedVolume,
      currentGoal,
      currentGoalExplanation,
    },
    validationObj,
  } = props;

  return (
    <div className="onboarding-step buying-criteria">
      <h2>How many properties do you currently own?</h2>
      <div style={{ maxWidth: '150px', marginBottom: '10px' }}>
        <ZorbaInput
          type="number"
          minValue="0"
          value={ownedVolume}
          fullWidth={false}
          symbol=""
          onChange={(e) => onChange(e, 'ownedVolume')}
        />
      </div>
      <span style={{ marginTop: '5px', color: 'red', display: 'inline-block' }}>
        {validationObj?.ownedVolume?.length > 0 ? 'Required' : ''}
      </span>
      <h2 style={{ marginTop: '10px' }}>
        How would you describe your investment strategy?
      </h2>
      <Checkbox.Group
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
        onChange={(values) => onChange(values, 'buyingStrategy')}
        value={buyingStrategy}
        options={[
          {
            value: 'fix_flip',
            label: 'Fix & Flip',
          },
          {
            value: 'buy_hold',
            label: 'Buy & Hold',
          },
        ]}
      />
      <span style={{ marginTop: '5px', color: 'red', display: 'inline-block' }}>
        {validationObj?.buyingStrategy?.length > 0 ? 'Required' : ''}
      </span>
      <h2>Are you currently looking to…</h2>
      <Radio.Group
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          fontSize: '16px',
        }}
        onChange={(e) => onChange(e.target.value, 'currentGoal')}
        value={currentGoal}
        options={[
          {
            label: 'Grow your portfolio',
            value: 'grow_portfolio',
          },
          {
            label: 'Exit some or all of your properties',
            value: 'exit',
          },
          {
            label: 'Just browsing for now',
            value: 'browsing',
          },
        ]}
      />
      <span style={{ marginTop: '5px', color: 'red', display: 'inline-block' }}>
        {validationObj?.currentGoal?.length > 0 ? 'Required' : ''}
      </span>
      {currentGoal && (
        <>
          <h2 style={{ marginTop: '10px' }}>
            {currentGoal === 'grow_portfolio' || currentGoal === 'browsing'
              ? `What's been the biggest challenge holding you back from scaling faster? (Select up to 2)`
              : 'Are you looking to sell:'}
          </h2>
          <Checkbox.Group
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }}
            onChange={(values) => {
              const limitedValues = values.slice(-2);
              onChange(limitedValues, 'currentGoalExplanation');
            }}
            value={currentGoalExplanation}
            options={
              currentGoal === 'grow_portfolio' || currentGoal === 'browsing'
                ? [
                    {
                      value: 'access_to_capital',
                      label: 'Access to capital',
                    },
                    {
                      value: 'access_to_great_off_market_deals',
                      label: 'Access to great off-market deals',
                    },
                    {
                      value: 'managing_rehabs',
                      label: 'Managing rehabs',
                    },
                    {
                      value: 'property_management',
                      label: 'Property management',
                    },
                    {
                      value: 'unclear_growth_strategy',
                      label: 'Unclear growth strategy',
                    },
                    {
                      value: 'time_focus',
                      label: 'Time & focus',
                    },
                  ]
                : [
                    {
                      value: 'entire_portfolio',
                      label: 'Entire Portfolio',
                    },
                    {
                      value: 'select_properties',
                      label: 'Select properties',
                    },
                    {
                      value: 'not_sure_yet',
                      label: 'Not sure yet – want to explore offers',
                    },
                  ]
            }
          />{' '}
          <span
            style={{ marginTop: '5px', color: 'red', display: 'inline-block' }}
          >
            {validationObj?.currentGoalExplanation?.length > 0
              ? 'Required'
              : ''}
          </span>
          {(currentGoal === 'grow_portfolio' || currentGoal === 'browsing') && (
            <>
              <h2 style={{ marginTop: '10px' }}>
                How many properties you intend to purchase in the next 12
                months?
              </h2>
              <Radio.Group
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8,
                  fontSize: '16px',
                }}
                onChange={(e) => onChange(e.target.value, 'buyingVolume')}
                value={buyingVolume}
                options={[
                  {
                    value: '1',
                    label: 'Buying my first property',
                  },
                  {
                    value: '1-2',
                    label: '1-2',
                  },
                  {
                    value: '3-9',
                    label: '3-9',
                  },
                  {
                    value: '10',
                    label: '10+',
                  },
                ]}
              />
              <span
                style={{
                  marginTop: '5px',
                  color: 'red',
                  display: 'inline-block',
                }}
              >
                {validationObj?.buyingVolume?.length > 0 ? 'Required' : ''}
              </span>
            </>
          )}
        </>
      )}
    </div>
  );
};
